module.exports = __webpack_public_path__ + "img/educationalTraining5.f7bf241c.png";